import type { FC } from 'react'
import { Global, css } from '@emotion/react'

import theme from '@segment/matcha/foundations/Theme'

import Layout from '../components/Layout'

import Form from './Form'

const SignUp: FC = () => {
  return (
    <Layout subnav={false} pageName="Sign up">
      <Global styles={Globals} />
      <Form />
    </Layout>
  )
}

const Globals = css`
  html {
    background-color: ${theme.palette.twilio.gray[10]};
  }
`

export default SignUp
